<template>
   <div>
    <div class="transaction-explorer mt-14 mb-14">
      <div class="mb-[10px]">
        <Paragraph class="text-blue-dark font-jost-regular text-[25px]" text="Coin Asset Account" />
        <div class="flex gap-[20px] max-w-max relative w-auto">
          <p class="text-blue-light break-all font-jost-regular w-full text-blue-light text-left" style="font-size: 25px">
            {{ publicAddress }}
            <span class="inline-block cursor-pointer" title="Copy hash">
              <CopyIcon :isActive="checkIfIsEqual(publicAddress)" @click="copy(publicAddress)" title="Copy hash"
                class="h-[33px] ml-2 inline-block cursor-pointer" />
            </span>
          </p>
        </div>
      </div>

      <section class="t-results justify-start gap-[40px] text-lg mt-5 mt-[105px] flex">
        <div>
          <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px] mb-[11px]" text="Overview" />

          <div v-if="loaders.accountDetails"
            class="overview__section bg-white rounded-[9px] flex justify-center w-full mt-[30px] w-[676px] h-[250px] items-center">
            <Loader color="#64748B" width="30px" height="30px" />
          </div>
          <section v-else class="overview__section w-[676px] flex flex-wrap gap-[100px]">
            <div v-if="!loaders.accountDetails && account && Object.keys(account).length"
              class="t-results-body bg-white w-full">
              <div>
                <div
                  class="row text-left items-center text-blue-dark py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    COIN Balance
                  </div>
                  <div class="col font-jost-regular text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ findAccountGeeqBalance(account.balances) }} GEEQ
                    </span>
                  </div>
                </div>
                <div
                  v-if="getOtherBalances(account.balances).length > 0"
                  class="row text-left items-center text-blue-dark py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Other Balances
                  </div>
                  <div class="col">
                    <DropdownComponent
                      :items="getOtherBalances(account.balances)"
                      @toggle="onBalancesDropdownToggle"
                    >
                      <template #trigger="{ isOpen }">
                        <span class="text-blue font-jost-bold text-[16px]">
                          {{ getOtherBalances(account.balances).length }}
                        </span>
                        <i :class="isOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'" class="text-blue-light text-sm transition-transform duration-200"></i>
                      </template>

                      <template #item="{ item }">
                        <div class="flex justify-between items-center">
                          <div>
                            <div class="font-medium text-blue-dark text-sm font-jost-regular">
                              {{ item.type.toUpperCase() }}
                            </div>
                            <div class="text-xs text-gray-500 mt-1 font-jost-regular" v-if="item.assetId">
                              Asset ID: {{ item.assetId }}
                            </div>
                          </div>
                          <div class="text-right">
                            <div class="font-semibold text-blue-dark font-jost-bold text-sm">
                              {{ getBalance(item.amount) }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </DropdownComponent>
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Chain Number
                  </div>
                  <router-link
                    v-if="account && account.chainNumber"
                    class="col text-blue-light cursor-pointer text-[16px]"
                    :to="{ name: 'chain', params: { chainNumber: account.chainNumber } }"
                  >
                    #{{ account.chainNumber }}
                  </router-link>
                  <div v-else class="col text-[16px]">
                    N/A
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Total Transactions
                  </div>
                  <div class="col">
                    <div class="flex gap-[5px] items-center">
                      <img src="/images/icons/sent-txs.png" />
                      <span class="font-jost-bold text-blue-dark text-[16px] leading-[26px]">
                        {{ account.outgoingTransactions }}
                      </span>

                      <img src="/images/icons/received-txs.png" />
                      <span class="font-jost-bold text-blue-dark text-[16px] leading-[26px]">
                        {{ account.incomingTransactions }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="row text-left items-center text-blue-dark py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Admin for
                  </div>
                  <div class="w-fit-content">
                    <DropdownComponent 
                      v-if="proxyAccounts.length > 0 || proxyAccountsMeta.count > 0"
                      :items="proxyAccounts"
                      :has-more-items="hasMoreProxyAccounts"
                      :is-loading="proxyAccountsLoading"
                      :total-count="proxyAccountsMeta.count"
                      :enable-infinite-scrolling="true"
                      @toggle="onProxyAccountsDropdownToggle"
                      @load-more="loadMoreProxyAccounts"
                    >
                      <template #trigger="{ isOpen, totalCount }">
                        <span class="text-blue-dark font-jost-regular text-[16px]">
                          {{ totalCount || 0 }} Proxy Accounts
                        </span>
                        <i :class="isOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'" class="text-blue-light text-sm transition-transform duration-200"></i>
                      </template>
                      
                      <template #item="{ item }">
                        <router-link 
                          :to="{ name: 'account', params: { chainNumber: chainNumber, walletAddress: item } }"
                          class="flex justify-between items-center hover:bg-blue-50 px-4 py-3 -mx-4 -my-3 transition-colors duration-200 rounded-md group"
                        >
                          <div class="flex-1">
                            <div class="font-medium text-blue-dark text-sm font-jost-regular group-hover:text-blue-light transition-colors duration-200">
                              {{ getShortenedText(item) }}
                            </div>
                          </div>
                          <div class="text-right ml-3">
                            <i class="fa fa-external-link text-blue-light text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-200"></i>
                          </div>
                        </router-link>
                      </template>
                      
                      <template #empty>
                        <div class="px-4 py-3 text-gray-500 text-sm text-center">
                          No proxy accounts
                        </div>
                      </template>
                    </DropdownComponent>
                    <span v-else class="text-gray-500 text-sm">No proxy accounts</span>
                  </div>
                </div> -->

                <div
                  class="row text-left items-center text-blue-dark py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Created At
                  </div>

                  <div class="font-jost-regular text-blue-dark text-[16px]">
                    <router-link v-if="account && account.blockNumber" class="block flex relative cursor-pointer text-[16px] text-blue-light"
                      :to="{ name: 'block', params: { chainNumber: account.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: account.blockNumber } }">
                      Block #{{ account.blockNumber }}
                    </router-link>
                    {{ getTxCreationDateUtc() }} UTC
                  </div>
                </div>
              </div>
            </div>
            <Paragraph text="We couldn't find any results.." class="text-blue-dark text-lg mt-5 float-left" v-else />
          </section>
        </div>
        <OwnedNftsPanel :account-address="publicAddress" :chain-number="chainNumber" />

      </section>
        <div>
        <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[30px] mt-[82px] mb-[10px]"
          text="Transactions" />
        <div v-if="loaders.transactions" class="flex items-center justify-center py-6">
          <Loader color="#64748B" width="30px" height="30px" />
        </div>
        <template v-else>
          <SearchableTable
            :transactions="coinAccountTransactions"
            :copied="copied"
            :initialFilters="searchableTableInitialFilters"
            :accountAddress="publicAddress"
            @copied="handleCopied"
            @filtersChanged="handleFiltersChanged"
          />
          <div class="flex justify-end px-[25px]">
            <pagination-component :items="coinAccountTransactions.totalCount || 0" :initialPage="getInitialPage()"
              @changePage="setFoundResult" class="float-left" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-json-pretty/lib/styles.css";
import { mapGetters } from 'vuex';
import api from '@/helpers/api';
import string from '@/helpers/string';
import CopyIcon from '@/components/svg/CopyIcon';
import Loader from '@/components/common/Loader.vue';

import Paragraph from "@/components/web/ParagraphComponent";
import DropdownComponent from "@/components/common/DropdownComponent";
import SearchableTable from '@/components/common/SearchableTable.vue';
import PaginationComponent from "../common/PaginationComponent.vue";
import OwnedNftsPanel from '@/components/web/OwnedNftsPanel.vue';

import { maxTableRows } from "@/utils/pagination";
import moment from 'moment';

const TRANSACTION_TYPE_VALUES = ['attestCommit', 'coin', 'proxyCreate', 'nftMint'];

export default {
  name: "CoinAccountComponent",
  components: {
    PaginationComponent,
    CopyIcon,
    Loader,
    Paragraph,
    DropdownComponent,
    SearchableTable,
    OwnedNftsPanel
  },
  props: {
    walletAddress: {
      required: true
    },
    publicAddress: {
      required: true
    },
  },
  computed: {
    chainNumber() {
      return this.$route.params.chainNumber ? parseInt(this.$route.params.chainNumber, 10) : undefined;
    },
    ...mapGetters({
      isLoadingInProgress: 'getIsLoadingInProgress',
    }),
    routeName() {
      return this.$route.name
    },
    searchableTableInitialFilters() {
      return {
        from: this.publicAddress || '',
        to: this.publicAddress || '',
      };
    },
    hasMoreProxyAccounts() {
      return this.proxyAccounts.length < this.proxyAccountsMeta.count;
    },
  },
  data: () => {
    return {
      proxyAccounts: [],
      proxyAccountsMeta: {
        skip: 0,
        limit: 20,
        count: 0
      },
      proxyAccountsLoading: false,
      coinAccountTransactions: {
        totalCount: 0,
        items: [],
        skip: 0,
      },
      loaders: {
        accountDetails: true,
        transactions: false,
      },
      account: null,
      copied: '',
      initialPage: 1,
      pageSize: maxTableRows,
      transactionFilters: {
        from: '',
        to: '',
        type: [...TRANSACTION_TYPE_VALUES],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: ['valid', 'invalid']
      },
      transactionRefHash: "",
      balanceDivisor: parseInt(process.env.VUE_APP_BALANCE_DIVISOR, 10) || 1000000000,
      isLoading: false,
      virtualFlag: false,   // vue-json-pretty setting
      showLine: true,
      lastPath: null,
      collapsedOnClickBrackets: true,
      stackTxsDetails: null,
      currentScrollItem: 1,
      transactionData: {},
      uatOrderedSample: {
        "uatData": null,
        "signature": null,
      },
      uatDataOrderedSample: {
        "groupType": null,
        "blockNumber": null,
        "chainNumber": null,
        "userPublicKey": null,
        "payloadRefHash": null,
      },
    }
  },

  created() {
    this.lastPath = this.$router.options.history.state.back;
    this.searchByAccPublicAddress(this.walletAddress);
    this.getProxyAccountsForCoinAccount(this.walletAddress, 20, 0, false);
    this.initializeTransactionFilters();
    this.fetchTransactions(0);
  },
  methods: {
    initializeTransactionFilters() {
      this.transactionFilters = {
        from: this.publicAddress,
        to: this.publicAddress,
        type: [...TRANSACTION_TYPE_VALUES],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: ['valid', 'invalid']
      };
    },
    fetchTransactions(skip = 0) {
      this.loaders.transactions = true;

      const params = {
        chainNumber: this.chainNumber ? parseInt(this.chainNumber, 10) : undefined,
        from: this.transactionFilters.from,
        to: this.transactionFilters.to,
        type: this.transactionFilters.type,
        minBlock: this.transactionFilters.minBlock,
        maxBlock: this.transactionFilters.maxBlock,
        dateFrom: this.transactionFilters.dateFrom,
        dateTo: this.transactionFilters.dateTo,
        status: this.transactionFilters.status,
        limit: maxTableRows,
        skip,
      };

      api.getTransactionsByType(params)
        .then((res) => {
          this.coinAccountTransactions = {
            ...res.data,
            skip,
          };
          this.loaders.transactions = false;
        })
        .catch(() => {
          this.loaders.transactions = false;
        });
    },
    getItem(page) {
      const normalizedPage = Number(page) > 0 ? Number(page) : 1;
      const skip = (normalizedPage - 1) * maxTableRows;
      this.fetchTransactions(skip);
    },
    getInitialPage() {
      const skip = this.coinAccountTransactions?.skip
        ?? this.coinAccountTransactions?.meta?.skip
        ?? 0;
      return Math.floor(skip / this.pageSize) + 1;
    },
    handleFiltersChanged(filterData) {
      const types = Array.isArray(filterData.type)
        ? filterData.type
        : (filterData.type ? [filterData.type] : []);

      const statuses = Array.isArray(filterData.status)
        ? filterData.status
        : (filterData.status ? [filterData.status] : []);
      const fromAddress = typeof filterData.from === 'string' && filterData.from.trim()
        ? filterData.from.trim()
        : undefined;
      const toAddress = typeof filterData.to === 'string' && filterData.to.trim()
        ? filterData.to.trim()
        : undefined;

      this.transactionFilters = {
        from: fromAddress,
        to: toAddress,
        type: types,
        minBlock: filterData.blockMin ?? undefined,
        maxBlock: filterData.blockMax ?? undefined,
        dateFrom: filterData.dateFrom ?? undefined,
        dateTo: filterData.dateTo ?? undefined,
        status: statuses,
      };
      this.fetchTransactions(0);
    },
    findAccountGeeqBalance(balances) {
      if (!balances || !balances.length) {
        return '0';
      }
      const geeqBalanceObj = balances.find(balance => balance.type === 'geeq');
      return geeqBalanceObj ? this.getBalance(geeqBalanceObj.amount) : '0';
    },
    getBalance(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return amount;
      }

      const parsedAmount = Number(amount);

      if (Number.isNaN(parsedAmount) || !this.balanceDivisor) {
        return amount;
      }

      return parsedAmount / this.balanceDivisor;
    },
    getOtherBalances(balances) {
      if (!balances || !balances.length) {
        return [];
      }
      return balances.filter((balance) => {
        if (!balance || !balance.type) return true;
        return balance.type.toLowerCase() !== 'geeq';
      });
    },
    onBalancesDropdownToggle(isOpen) {
      // Handle dropdown toggle if needed
      // console.log('Balances dropdown toggled:', isOpen);
    },
    onProxyAccountsDropdownToggle(isOpen) {
      // Handle proxy accounts dropdown toggle if needed
      // console.log('Proxy accounts dropdown toggled:', isOpen);
    },
    loadMoreProxyAccounts() {
      if (this.proxyAccountsLoading || !this.hasMoreProxyAccounts) {
        return;
      }

      const nextSkip = this.proxyAccountsMeta.skip + this.proxyAccountsMeta.limit;
      this.getProxyAccountsForCoinAccount(this.walletAddress, this.proxyAccountsMeta.limit, nextSkip, true);
    },
    setPageLoaderState(isLoading) {
      this.$store.commit('setIsLoadingInProgress', isLoading);
    },
    // searchByAccPublicAddress(address) {
    //   this.setPageLoaderState(true);

    //   return api.getCoinAccountDetails(address)
    //     .then((res) => {
    //       const data = res.data;
    //       this.account = data.result;
    //       this.setPageLoaderState(false);
    //     })
    //     .catch(() => {
    //       this.setPageLoaderState(false);
    //     })
    // },
    setCopied(hash) {
      this.copied = hash;
    },
    handleCopied(copiedText) {
      this.copied = copiedText;
    },
    getShortenedText(str) {
      return string.getShortenHash(str)
    },
    getTxCreationDateUtc() {
      const createdAt = this.account.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment.utc(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    setFoundResult(data) {
      const page = data?.page;
      this.getItem(page || 1);
    },

    getTitle() {
      return this.routeName === "transaction" ? "AppCommitHash" : "RefHash"
    },
    goBack() {
      this.$router.push({name: 'search-result'})
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setupTransactionData() {
      if (!this.transactionData || !this.transactionData.uat) return;
      this.transactionRefHash = this.txRefHash || this.transactionData.uat.uatData.refHash;

      this.transactionData.uat = Object.assign(this.uatOrderedSample, this.transactionData.uat);

      for (const key in this.uatDataOrderedSample) {
        this.uatDataOrderedSample[key] = this.transactionData.uat.uatData[key];
        if (key === 'userPublicKey') {
          this.uatDataOrderedSample[key] = this.transactionData.uat.uatData.pubKeyUser;
        }
      }
      this.transactionData.uat.uatData = Object.assign(this.uatDataOrderedSample)
    },
    searchByAccPublicAddress() {
      this.loaders.accountDetails = true;

      return api.getCoinAccountDetails(this.walletAddress, this.chainNumber)
        .then((res) => {
          const data = res.data;
          this.account = data.result;
          
          this.loaders.accountDetails = false;

      })
      .catch(() => {
        this.loaders.accountDetails = false;
      })
    },
    getProxyAccountsForCoinAccount(accountAddress = '', limit = 20, skip = 0, append = false) {
      this.proxyAccountsLoading = true;

      return api.getProxyAccountsForCoinAccount(accountAddress, limit, skip, this.chainNumber)
        .then((res) => {
          const data = res.data;
          const newAccounts = data.result || [];
          
          if (append) {
            // Append new accounts to existing ones
            this.proxyAccounts = [...this.proxyAccounts, ...newAccounts];
          } else {
            // Replace existing accounts (initial load)
            this.proxyAccounts = newAccounts;
          }
          
          // Update meta information
          this.proxyAccountsMeta = {
            skip: data.meta?.skip || skip,
            limit: data.meta?.limit || limit,
            count: data.meta?.count || newAccounts.length
          };
          
          this.proxyAccountsLoading = false;
        })
        .catch((err) => {
          console.error('Error fetching proxy accounts:', err);
          this.proxyAccountsLoading = false;
        });
    },
  }
}
</script>
<style>
* {
  font-family: 'Jost-regular', sans-serif;
}
.transaction-explorer .vjs-value {
  color: #2699FB!important;
  font-size: 16px;
  line-height: 26px;
  font-family: 'Inter-Regular', monospace !important;
}
.transaction-explorer .vjs-tree {
  font-size: 16px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
}
.transaction-explorer .vjs-key {
  font-family: 'Inter-Regular', monospace !important;
}
</style>
<style scoped>
.col {
  width: 30%;
}
.t-results-body {
  padding: 15px 15px 10px 15px;
  border-radius: 9px 9px 9px 9px;
}
.t-results-body .row:first-child {
  border-top: unset;
}
.is-active {
  background-color: #D66339;
}
.flex__col__1 {
  max-width: 100px;
}
@media(max-width:1750px){
  .t-results {
    gap: 20px;
  }
}
@media(max-width:1500px){
  .overview__section {
    max-width: 570px;
  }
}
@media (max-width: 767px) {
  .main-container {
    padding: 20px 0px !important;
  }
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 680px;
  }
}
@media (max-width: 715px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 600px;
  }
}
@media (max-width: 620px) {

  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 500px;
  }
}
@media (max-width: 520px) {

  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 400px;
  }
}
@media (max-width: 420px) {

  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 100%;
  }
}
@media (max-width: 390px) {
  .overview__section {
    width: 320px;

  }
  .flex__col__1 img {
    width: 50px;
  }
}

</style>
